import { useFormik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { addTrustedInstitute, editTrustedInstitute, getSingleTrustedInstitute } from "../../redux/services/trustedInstituteSlice";
import { fileUpload } from "../../redux/services/fileUploadSlice";
import { ROUTES } from "../../constant";

const TrustedByForm = ({ action }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getSingleTrustedData = useSelector((state) => state.trustedInstitute.singleTrustedByData);
  const queryParams = new URLSearchParams(location.search);
  const trustedId = queryParams.get("trustedId");
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);

  const initialValues = {
    image: "",
    link: "",
  };

  const validationSchema = Yup.object({
    image: Yup.string().required("Image is required"),
    link: Yup.string().required("Link is required"),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      if (trustedId) {
        values.trustedInstituteId = trustedId;
      }
      let response;
      if (trustedId) {
        response = await dispatch(editTrustedInstitute(values));
      } else {
        response = await dispatch(addTrustedInstitute(values));
      }
      if (response?.payload?.status === 200) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        setLoading(false);
        navigate(ROUTES.WEBSITE.TRUSTED_BY);
        resetForm();
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  const getSingleRecord = useCallback(async () => {
    try {
      await dispatch(getSingleTrustedInstitute(trustedId));
    } catch (error) {}
  }, [dispatch, trustedId]);

  useEffect(() => {
    if (trustedId) {
      getSingleRecord();
    }
  }, [trustedId, getSingleRecord]);

  useEffect(() => {
    if (trustedId && getSingleTrustedData) {
      setValues({
        image: getSingleTrustedData?.image ?? "",
        link: getSingleTrustedData?.link ?? "",
      });
      setPreview(getSingleTrustedData?.image ?? null);
    }
  }, [trustedId, getSingleTrustedData, setValues]);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const imageURL = URL.createObjectURL(file);
    setPreview(imageURL);
    const formData = new FormData();
    formData.append("image", file);
    try {
      const response = await dispatch(fileUpload(formData));
      if (response) {
        const url = response.payload?.fileUrl || response.payload;
        setValues({ ...values, image: url });
      }
    } catch (error) {}
  };

  return (
    <div>
      <div className="bg-background py-4 sm:py-4">
        <div className="px-4 md:py-10 py-5 bg-card shadow rounded-3xl sm:p-10">
          <p className="md:text-3xl text-xl text-center font-medium uppercase text-primary">
            {action} Trusted By
          </p>
          <form className="mt-6" onSubmit={handleSubmit}>
            <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
              <div>
                <label className="text-sm font-medium text-foreground">Image</label>
                <input
                  type="file"
                  name="image"
                  onChange={handleImageChange}
                  className="w-full px-4 py-2 border border-border rounded-xl"
                />
                {touched.image && errors.image && (
                  <div className="text-red-500 text-sm">{errors.image}</div>
                )}
                {preview && (
                  <div className="mt-4 flex">
                    <p className="text-md text-foreground me-3">Preview:</p>
                    <img
                      src={preview}
                      alt="preview"
                      className="w-20 h-20 object-cover border border-border rounded-xl"
                    />
                  </div>
                )}
              </div>

              <div>
                <label className="text-sm font-medium text-foreground">Link</label>
                <input
                  type="text"
                  name="link"
                  className="w-full px-4 py-2 border border-border rounded-xl bg-card"
                  value={values.link}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="https://..."
                />
                {touched.link && errors.link && (
                  <div className="text-red-500 text-sm">{errors.link}</div>
                )}
              </div>
            </div>
            <div className="flex justify-center">
              <button
                type="submit"
                className="w-full sm:w-[250px] min-h-[50px] flex justify-center items-center text-white bg-primary text-lg font-semibold rounded-xl hover:bg-accent mt-7"
              >
                {loading ? <div className="loader"></div> : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TrustedByForm;


